/**
 * JS color tokens for Material-UI APIs that cannot parse CSS variables
 * (createTheme palette, withStyles color manipulation, etc.).
 *
 * Keep in sync with :root variables in src/dark-mode-theme.css
 */
export const PRIMARY_THEME_COLOR = "#56e4d7";
